import React, { Component } from "react";
import { connect } from "react-redux";

import {
  INAPPROPRIATE_REQUESTED,
  COMMENT_VOTE_REQUESTED
} from "../../actions.js";
import CommentCard from "../../components/CommentCard.js";

class CommentsColumn extends Component {
  render() {
    if (this.props.comments.length === 0) {
      return (
        <p className="lead text-center">
          Todavía no han escrito de este profesor. ¡Sé el primero!
        </p>
      );
    }

    var col = [];
    for (let c of this.props.comments) {
      const vote = this.props.commentVotes[c.id];
      col.push(
        <CommentCard
          key={c.id}
          comment={c}
          onInappropriate={this.props.onInappropriate}
          canUpvote={vote === undefined || !vote}
          canDownvote={vote === undefined || vote}
          onUpvote={this.props.onUpvote}
          onDownvote={this.props.onDownvote}
        />
      );
    }
    return col;
  }
}

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => {
  return {
    onInappropriate: comment => {
      dispatch({ type: INAPPROPRIATE_REQUESTED, comment: comment });
    },
    onUpvote: comment => {
      dispatch({
        type: COMMENT_VOTE_REQUESTED,
        comment: comment,
        upvote: true
      });
    },
    onDownvote: comment => {
      dispatch({
        type: COMMENT_VOTE_REQUESTED,
        comment: comment,
        upvote: false
      });
    }
  };
};

const CommentsColumnContainer = connect(mapStateToProps, mapDispatchToProps)(
  CommentsColumn
);

export default CommentsColumnContainer;



// WEBPACK FOOTER //
// ./src/containers/profecomments/CommentsColumnContainer.js